import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const APPROVE_EXPENSE_REPORT = gql`
  mutation ApproveExpenseReport($uuid: ID!, $approvalStatus: ExpenseReportApprovalStatus!, $impactsOverflow : Boolean!, $adminComment : String, $paymentDate:Date) {
    approveExpenseReport(approvedExpenseReport: { 
    uuid: $uuid, 
    approvalStatus: $approvalStatus 
    impactsOverflow: $impactsOverflow
    adminComment: $adminComment
    paymentDate: $paymentDate
    
     })
  }
`;

export const useApproveExpenseReport = () => {
  const [approveExpenseReportMutation, { loading, error, data }] = useMutation(APPROVE_EXPENSE_REPORT);

  const approveExpenseReport = async (uuid, approvalStatus, impactsOverflow, adminComment, paymentDate) => {
    const response = await approveExpenseReportMutation({
      variables: { uuid, approvalStatus , impactsOverflow, adminComment, paymentDate},
    });
    return response.data.approveExpenseReport;
  };

  return { approveExpenseReport, loading, error, data };
};
